require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-personal-health-savings-account.json") })
        }
      }, "path---es-personal-health-savings-account");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-personal-health-savings-account!./.cache/json/es-personal-health-savings-account.json
// module id = 2595
// module chunks = 231608221292675